// covered-by: frontends/carrie/src/ask-v2/pages/__tests__/AskV2ChatsPage.test.tsx
import { useNavigate } from "@tanstack/react-router";

import {
  AskPunttChatsView,
  type ChatListItem,
} from "../../components/ask-puntt-list/AskPunttChatsView";
import {
  ASK_V2_CHAT_PATH,
  ASK_V2_CHATS_PATH,
  ASK_V2_HOME_PATH,
} from "../paths";

export function AskV2ChatsPage() {
  const navigate = useNavigate();

  return (
    <div
      data-testid="ask-v2-chats-page"
      className="flex min-h-0 flex-1 flex-col"
    >
      <AskPunttChatsView
        listTo={ASK_V2_CHATS_PATH}
        onOpenChat={(chat: ChatListItem) => {
          void navigate({
            to: ASK_V2_CHAT_PATH,
            params: { chatId: chat._id },
          });
        }}
        onNewChat={() => {
          void navigate({ to: ASK_V2_HOME_PATH });
        }}
      />
    </div>
  );
}
